import React from 'react';

const Question = ({ questionText, answers, selectedAnswers, onAnswerClick, showCorrectAnswer, correctAnswers }) => {
    return (
        <div className="question">
            <h2>{questionText}</h2>
            <ul>
                {Object.entries(answers).map(([key, answer]) => {
                    let className = '';
                    if (showCorrectAnswer) {
                        if (correctAnswers.includes(key)) {
                            className = 'correct';
                        } else {
                            className = 'incorrect';
                        }
                    }
                    if (selectedAnswers.includes(key)) {
                        className += ' selected';
                    }
                    return (
                        <li
                            key={key}
                            className={className.trim()}
                            onClick={() => !showCorrectAnswer && onAnswerClick(key)} // Disable click if showCorrectAnswer is true
                        >
                            {answer}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default Question;